import React, { useEffect, useRef } from "react";
import type { StreamItem } from "../../types/meeting.types";
import { Hand } from "lucide-react";

interface Props {
  stream: StreamItem;
  handRaised?: boolean;
}

export const BigVideo: React.FC<Props> = ({ stream, handRaised = false }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  /* ================================
     Attach Media Stream
  ================================= */
  useEffect(() => {
    if (!videoRef.current) return;

    videoRef.current.srcObject = stream.stream;
  }, [stream.stream]);

  /* ================================
     Freeze / Unfreeze Logic
  ================================= */
  useEffect(() => {
    if (!videoRef.current) return;

    if (stream.frozen) {
      videoRef.current.pause();
    } else {
      videoRef.current.play().catch(() => {});
    }
  }, [stream.frozen]);

  return (
    <div className={`big-video-container relative ${handRaised ? "border-3 border-amber-400" : ""}`}>
      {/* Video */}
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted={stream.isLocal}
        className={`big-video ${stream.blurred ? "blurred" : ""}`}
      />

      {/* Overlays */}
      {stream.videoPaused && (
        <div className="overlay video-off">📷 Video Off</div>
      )}

      {stream.audioPaused && <div className="overlay muted">🔇 Muted</div>}

      {handRaised && (
        <span title="Hand raised" role="img" aria-label="Hand raised" className="absolute bottom-16 right-3 z-20 rounded-full bg-amber-400 p-2 text-amber-950 shadow-lg">
          <Hand className="h-6 w-6" aria-hidden="true" />
        </span>
      )}

      {/* User Name */}
      <div className="big-video-name">{stream.name}</div>
    </div>
  );
};
